/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { Button, Divider } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose } from 'recompose';
import { makeStyles } from '@material-ui/styles';
import {
    array, arrayOf, bool, func, number, object, shape, string,
} from 'prop-types';
import EventIcon from '@material-ui/icons/Event';
import { useLazyQuery, useQuery } from '@apollo/client';
import Header from './Partials/Header';
import {
    capitalize, copyQueryBuilder, defaultSelectionQuery, getIdByLabel,
} from '../GraphqlProductPage/Partials/Subscription/Helper';
import { getBrand } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { setSubscriptionDetail } from '../../../../state/ducks/App/App-Actions';
import subscriptionConfig from '../../../helpers/common/subscription/subscription-helpers';
import findContent from '../../../gql/queries/findContent';
import FrequencyDropdown from './Partials/FrequencyDropdown';
import DurationDropdown from './Partials/DurationDropdown';
import GraphqlCalendarContainer from '../GraphqlProductPage/Partials/GraphqlPDPCalendar/GraphqlCalendarContainer';
import { getSkuWithoutBrand } from '../../../helpers/common/helper';
import { filterInternationalCountry } from '../../../../state/ducks/Checkout/ducks/Checkout/Checkout-Helper';
import Overlay from './Partials/Overlay';
import { getUserSubmittedProductFilterZipcode } from '../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import GraphqlPortalLoader from '../GraphqlCommonComponents/GraphqlPortalLoader';
import { isEmpty } from '../../../pages/Account/utils/object';

const useStyles = makeStyles((theme) => ({
    container: {
        position: 'relative',
        '& .MuiDivider-root': {
            maxWidth: '1300px',
            margin: '0 auto',
        },
        '& .MuiButton-root': {
            color: theme.palette.white,
            textTransform: 'uppercase',
            fontSize: '13px',
            marginTop: '40px',
            padding: '5px 60px',
            fontWeight: '700',
            width: 'fit-content',
            backgroundColor: theme.palette.colorPrimary,
            '-webkit-font-smoothing': 'antialiased',
            '&:hover': {
                backgroundColor: theme.palette.colorPrimary,
            },
        },
    },
    subContainer: {
        padding: '50px 0',
        '@media screen and (max-width: 768px)': {
            padding: '50px 20px',
        },
    },
    formContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        margin: 'auto',
        '@media screen and (max-width: 768px)': {
            alignItems: 'center',
            flexDirection: 'column',
        },
        '& > div': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            maxWidth: '360px',
            minHeight: '50px',
            textAlign: 'center',
            textTransform: 'uppercase',
            margin: '0 10px',
            '@media screen and (max-width: 768px)': {
                margin: '10px 0',
            },
        },
        '& > div:nth-child(1), & > div:nth-child(3), & #calendar': {
            width: '100%',
            border: '1px solid rgb(0,0,0, 0.3)',
        },
        '& #calendar': {
            flexDirection: 'row !important',
            padding: '13px 0 !important',
            '& svg': {
                fontSize: '18px',
                marginLeft: '10px',
            },
        },
    },
    calender: {
        padding: '10px 0',
        cursor: 'pointer',
    },
    error: {
        fontSize: '12px',
        marginTop: '5px',
        textAlign: 'center',
        color: 'red !important',
    },
    errorField: {
        border: '1px solid red !important',
    },
}));

const Frequency = ({
    frequeContainerData,
    subscriptionDetails,
    subscription,
    brand,
    product,
    subscriptionsList, // redux data
    setSubscriptionDetailData,
    selectedSku,
    addToCartData,
    validatedZip, setAddToCartData,
    scrollDownToSection,
    trackEvent,
}) => {
    // eslint-disable-next-line no-unused-vars
    const [subscriptionCopy, setSubscriptionCopy] = useState({});
    const [toggleCalender, setToggleCalender] = useState(false);
    const [calendarIsLoading, setCalendarIsLoading] = useState(false);
    const [deliveryAvailable, setDeliveryAvailable] = useState(true);
    const [date, setDate] = useState('');
    const [hasError, setHasError] = useState(false);
    const classes = useStyles();
    const heading = frequeContainerData?.title || '';
    const subHeading = frequeContainerData?.sub_title || '';
    const discoveryViews = ['discovery', 'monthonly', 'monthonlypayfull'];
    const isTypeDiscovery = discoveryViews.includes(selectedSku?.subscriptions?.type?.toLowerCase?.());
    const subscriptionType = isTypeDiscovery ? 'Discovery' : 'Basic';
    let defaultOptions = {};
    let defaultSubscriptionCopy = {};

    const skuSubscriptionType = capitalize(selectedSku?.subscriptionsList?.type?.[0] || '') || subscriptionType;

    /**
     * getting Data for default selection of dropdown Code START
     */

    const csEntryTitle = `Default ${skuSubscriptionType?.toLowerCase?.() || ''}`;

    const findContentDefaultOptions = defaultSelectionQuery(csEntryTitle, brand);
    const defaultDropdownQuery = findContent(findContentDefaultOptions);
    const [getDefaultOptions, {
        data,
    }] = useLazyQuery(defaultDropdownQuery);

    useEffect(() => {
        if (data) {
            defaultOptions = {
                frequency: data?.findContent?.content?.entries?.[0]?.subscription_interval,
                duration: data?.findContent?.content?.entries?.[0]?.subscription_duration,
                interval: data?.findContent?.content?.entries?.[0]?.subscription_type,
            };
            defaultSubscriptionCopy = data?.findContent?.content?.entries?.[0] || {};

            // updating same option in Redux
            setSubscriptionDetailData(defaultSubscriptionCopy);
        }
    }, [data]);

    // ------------------------- //

    /**
     * Setting default duration data.
     */
    const [durationValue, setDurationValue] = useState(subscriptionsList?.duration?.[0]  || product?.productSkus?.subscriptionsList?.duration?.[0] || 1);
    const durationText = subscriptionConfig.subscription_duration?.[durationValue];

    /**
     * Setting Interval/Frequency both are same
     */

    const [frequencyValue, setFrequencyValue] = useState(subscriptionsList?.interval?.[0] || product?.productSkus?.subscriptionsList?.interval?.[0] || 4); // set default value
    const frequencyText = subscriptionConfig.subscription_interval?.[frequencyValue];
    /** *
     *
     *  getting copy from CS based on duration, interval and Type.
     *
     */
    const findContentOptions = copyQueryBuilder(durationText, frequencyText, skuSubscriptionType, brand);
    const subscriptionCopyQuery = findContent(findContentOptions);
    const { data: subscriptionCopyData } = useQuery(subscriptionCopyQuery);

    useEffect(() => {
        setSubscriptionDetailData({});
        /**
         * getting copy from default entry
         */
        getDefaultOptions();
    }, []);

    useEffect(() => {
        setDeliveryAvailable(true);
        setHasError(false);
    }, [validatedZip]);

    useEffect(() => {
        if (selectedSku?.subscriptionsList?.interval) {
            setSubscriptionDetailData({
                duration: selectedSku.subscriptionsList.duration?.[0] || subscriptionsList.duration,
                interval: selectedSku.subscriptionsList.interval?.[0] || subscriptionsList.interval,
                subscriptionInterval: selectedSku.subscriptionsList.interval?.[0] || subscriptionsList.subscriptionInterval,
                subscriptionType: skuSubscriptionType || subscriptionsList.subscriptionType,
            });
        }
    }, [selectedSku?.id]);

    useEffect(() => {
        const frequencyDefault = getIdByLabel(subscriptionConfig.subscription_interval, defaultOptions?.frequency);
        const durationDefault = getIdByLabel(subscriptionConfig.subscription_duration, defaultOptions?.duration);

        const frequencyDefaultValue = selectedSku?.subscriptionsList?.interval?.includes?.(frequencyDefault) ? frequencyDefault : frequencyValue;
        const durationDefaultValue = selectedSku?.subscriptionsList?.duration?.includes?.(durationDefault) ? durationDefault : durationValue;

        // if value also available for sku
        setFrequencyValue(frequencyDefaultValue);
        setDurationValue(durationDefaultValue);

        const defaultSubscription = {
            duration: durationDefaultValue || selectedSku?.subscriptionsList?.duration?.[0] || subscriptionsList.duration,
            interval: frequencyDefaultValue || selectedSku?.subscriptionsList?.interval?.[0] || subscriptionsList.interval,
            subscriptionInterval: frequencyDefaultValue || selectedSku?.subscriptionsList?.interval?.[0] || subscriptionsList.subscriptionInterval,
            subscriptionType: skuSubscriptionType || subscriptionsList.subscriptionType,
        };
        // updating same option in Redux
        setSubscriptionDetailData(defaultSubscription);
    }, [defaultOptions?.frequency, defaultOptions?.duration, selectedSku?.id]);

    useEffect(() => {
        setSubscriptionCopy(subscriptionCopyData?.findContent?.content?.entries?.[0] || {});
    }, [subscriptionCopyData]);

    const getInternationalCountry = () => {
        let countryCode = '';
        if (selectedSku?.countries?.length > 0) {
            countryCode = filterInternationalCountry(selectedSku.countries);
        }
        return countryCode;
    };
    // eslint-disable-next-line no-shadow
    const handleSelectDate = (data) => {
        setHasError(false);
        let displayDate = new Date(data.date);
        displayDate = displayDate.toLocaleDateString(undefined, {
            weekday: 'long', month: 'short', day: 'numeric',
        });
        setDate(displayDate); // for display purposes only
        setAddToCartData(data); // for addToCart button
        setTimeout(() => {
            scrollDownToSection('frequency_container', 'auto');
        });
    };

    const handleContinue = () => {
        if (!deliveryAvailable && validatedZip) return;
        if (isEmpty(addToCartData)) {
            setHasError(true);
            return;
        }
        const cartData = { ...addToCartData };
        cartData.reqObj.subscription = { duration: durationValue, interval: frequencyValue, type: subscriptionType };
        // cartData.reqObj.priceRules = priceRule;
        setAddToCartData(cartData); // for addToCart button
        scrollDownToSection('order_summary_container');
        trackEvent('Subscriptions Experience', 'click – Step 3', 'Continue');
    };

    const handleCalender = (boolean) => {
        setToggleCalender(boolean);
        setCalendarIsLoading(boolean);
        setTimeout(() => {
            scrollDownToSection('frequency_container', 'auto');
        });
    };

    const handleDeliveryAvailability = (boolean) => {
        setDeliveryAvailable(boolean);
        setCalendarIsLoading(false);
        setToggleCalender(false);
        setHasError(false);
    };

    const setCalendarDataLoadingFlag = (boolean) => {
        setCalendarIsLoading(boolean);
    };

    return (
        <div className={classes.container} id="frequency_container">
            <div className={classes.subContainer}>
                <Header id="3" heading={heading} subHeading={subHeading} />
                <div className={classes.formContainer}>
                    <FrequencyDropdown
                        frequencyText={frequencyText}
                        setFrequencyValue={setFrequencyValue}
                        subscriptionsDetails={subscriptionsList}
                        setSubscriptionDetailData={setSubscriptionDetailData}
                        subscriptionsList={selectedSku?.subscriptionsList}
                    />
                    <div>
                        <div
                            id="calendar"
                            role="presentation"
                            className={`${classes.calender} ${(hasError || (!deliveryAvailable && validatedZip)) && classes.errorField}`}
                            onClick={() => handleCalender(true)}
                        >{(!isEmpty(addToCartData) && date) || 'Choose your start date'} <EventIcon />
                        </div>
                        {hasError && <div className={classes.error}>Please Select Start Date</div>}
                        {!deliveryAvailable && validatedZip && <div className={classes.error}>We are sorry, the product you have selected is not available for your address <b>{validatedZip}</b></div>}
                    </div>
                    <DurationDropdown
                        durationText={durationText}
                        setDurationValue={setDurationValue}
                        subscriptionsDetails={subscriptionsList}
                        setSubscriptionDetailData={setSubscriptionDetailData}
                        subscriptionsList={selectedSku?.subscriptionsList || {}}
                    />
                </div>
                <Button data-testid="continue-fcd" onClick={handleContinue}>Continue</Button>
            </div>
            <Divider />
            {calendarIsLoading && !(!deliveryAvailable && validatedZip !== '')  ? <GraphqlPortalLoader /> : null}
            {toggleCalender && (
                <GraphqlCalendarContainer
                    close={() => handleCalender(false)}
                    isOpen={toggleCalender}
                    selectedItemId={getSkuWithoutBrand(selectedSku?.id)}
                    productDeliveryType={product?.availability?.productDeliveryType}
                    setCalendarDataLoadingFlag={setCalendarDataLoadingFlag}
                    handleDeliveryAvailability={handleDeliveryAvailability}
                    orderItemId={product?.baseId}
                    brandId={product?.brandId}
                    pageType="subscriptionsExp"
                    partNumber={product?.partNumber || ''}
                    ageDetails={{}}
                    zipCode={validatedZip}
                    selectedSku={selectedSku}
                    productName={product?.name}
                    todayTomDateNotAvailText=""
                    isInternationalProduct={selectedSku?.isInternational || false}
                    internationalCountry={getInternationalCountry}
                    validatedZip={validatedZip}
                    isPassportBundleProduct={{}}
                    hasWine={selectedSku?.ageVerifyFlag}
                    isFlowersSubscriptionFeatureEnabled
                    isFlowersTempV1SubscriptionFeatureEnabled
                    subscription={subscription}
                    subscriptionDetails={subscriptionDetails}
                    handleMiniCartModalClick={() => {}}
                    showWrapup
                    productSkus={product?.productSkus}
                    isQuickviewOrigin
                    quickviewSelectDate={handleSelectDate}
                />
            )}
            {!validatedZip && <Overlay />}
        </div>
    );
};

Frequency.propTypes = {
    frequeContainerData: object.isRequired,
    scrollDownToSection: func.isRequired,
    subscriptionsList: shape({
        duration: arrayOf(
            number,
        ),
        type: arrayOf(
            string,
        ),
        interval: arrayOf(
            number,
        ),
    }),
    subscriptionDetails: shape({
        subscriptionType: string.isRequired,
        subscriptionDuration: string.isRequired,
        subscriptionFrequency: string.isRequired,
        subscriptionDurationKey: string.isRequired,
    }).isRequired,
    subscription: shape({
        subscriptionKey: array.isRequired,
        subscriptionIndefinite: string.isRequired,
        subscriptionType: array.isRequired,
        implementProductSubscription: bool.isRequired,
        viewSubscription: bool.isRequired,
        isTypeDiscovery: bool.isRequired,
        subscriptionCheckbox: bool.isRequired,
    }).isRequired,
    setSubscriptionDetailData: func.isRequired,
    brand: shape({
        domain: string,
    }).isRequired,
    product: object.isRequired,
    selectedSku: object.isRequired,
    validatedZip: string.isRequired,
    addToCartData: object.isRequired,
    setAddToCartData: func.isRequired,
    trackEvent: func.isRequired,
};

Frequency.defaultProps = {
    subscriptionsList: {},
};

const mapDispatchToProps = (dispatch) => ({
    setSubscriptionDetailData: bindActionCreators(setSubscriptionDetail, dispatch),
});

const mapStateToProps = (state) => ({
    brand: getBrand(state),
    subscriptionsList: state.ui.subscriptionDetail,
    validatedZip: getUserSubmittedProductFilterZipcode(state),
});

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(Frequency);
